<template>
  <div>
    <LazyExperienceListHero />
    <LazyExperienceList
      class="addition-layout-padding mt-[24px] md:mt-[50px]"
      :initial-facets="discoverFacets"
      is-supplier
    />
    <!-- <LazyDiscoverFaq :faq-items="faqItems" /> -->
    <div v-if="faq.length" class="mt-[100px] container">
      <component
        :is="asyncFaqComponent"
        :faq-items="faqItems"
        v-bind="faqProps"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useAsyncData } from "nuxt/app";
import type { IFaqItem, ITestimonial, IProduct } from "../../../types/general";

type IFaq = { question: string; answer: string };
const runtimeConfig = useRuntimeConfig();
const siteConfig = useSiteConfig();
const localePath = useLocalePath();
const config: any = useRuntimeConfig();
const [{ data: discoverFacets }, { data: meta }, { data: experiences }] =
  await Promise.all([
    useAsyncData<any>("supplier-facets", () =>
      customFetch(`api/v2/products/facets`),
    ),
    useAsyncData<any>("experiences-meta", () =>
      customFetch("api/meta-data/page/experiences"),
    ),
    useAsyncData<any>("experiences", () => customFetch("api/v2/products")),
  ]);
const metaTags = ref(meta.value);
const { t } = useI18n();
const discoverHeader = ref(
  (config.public.supplierStatic as any).discoverHeader,
);
const parseTranslations = (data) => {
  return data.replace(/t\(([^)]+)\)/g, (match, p1) => {
    return t(p1);
  });
};

useSeoMeta({
  ogTitle: metaTags.value?.title
    ? metaTags.value.title
    : parseTranslations(discoverHeader.value.title),
  title: metaTags.value?.title
    ? metaTags.value.title
    : parseTranslations(discoverHeader.value.title),
  description: metaTags.value?.description
    ? metaTags.value.description
    : parseTranslations(discoverHeader.value.description),
  ogDescription: metaTags.value?.description
    ? metaTags.value.description
    : parseTranslations(discoverHeader.value.description),
  ogImage: discoverHeader.value?.image,
});
const socialMedia = siteConfig.company.social_medias.map((item) => item.url);
const comments: ITestimonial[] =
  (runtimeConfig.public.statics as any)?.testimonials ?? [];

// const productSchema = {
// "@context": "http://schema.org/",
// "@type": "Product",
// name: parseTranslations(discoverHeader.value?.title),
// image: discoverHeader.value?.images?.[0],
// description: parseTranslations(discoverHeader.value?.description),
// brand: {
//   "@type": "Brand",
//   name: siteConfig.company.organization.name,
// },
// offers: {
//   "@type": "AggregateOffer",
//   url: "",
//   priceCurrency: "SAR",
//   lowPrice: lowPrice.value,
//   highPrice: highPrice.value,
// },
// };

useHead({
  title: metaTags.value?.title
    ? metaTags.value.title
    : parseTranslations(discoverHeader.value.title),
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify(
        useOrganizationSchema(metaTags.value, socialMedia, comments),
      ),
    },
    {
      type: "application/ld+json",
      children: JSON.stringify(
        useLocalBusinessSchema(metaTags.value, socialMedia, comments),
      ),
    },
    ...(experiences.value?.length
      ? [
          {
            type: "application/ld+json",
            children: JSON.stringify(
              useProductListSchema(
                experiences.value,
                metaTags.value?.title ??
                  parseTranslations(discoverHeader.value.title),
                metaTags.value?.description,
                siteConfig.url,
                true,
                (path) => siteConfig.url.replace(/\/+$/, "") + localePath(path),
              ),
            ),
          },
        ]
      : []),
  ],
});

const faq: IFaqItem[] | [] = (config.public.statics.faq as IFaqItem[]) ?? [];
let faqItems: IFaq[] | [] =
  faq.map((val: IFaqItem) => ({
    question: val.title,
    answer: val.content,
  })) ?? [];
const asyncFaqComponent = ref<any>(
  defineAsyncComponent(() => import("../DiscoverFaq.vue")),
);
const faqName = ref<string>();
const faqProps = ref<Object>({});
if ((config.public.statics as any)?.faqComponent?.title) {
  faqName.value = (config.public.statics as any)?.faqComponent?.title;
  faqProps.value = (config.public.statics as any)?.faqComponent?.props;
  asyncFaqComponent.value = defineAsyncComponent(
    () =>
      import(
        `../../faq/${(config.public.statics as any)?.faqComponent?.title}.vue`
      ),
  );
}
</script>
